import React, { useEffect, useState } from "react";
import { Autocomplete, TextField, CircularProgress } from "@mui/material";
import axios from "axios";

export default function EntitySelector({ value, onChange }) {
  const [options, setOptions] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (inputValue.length === 0) {
      setOptions([]);
      return;
    }

    const fetchSuggestions = async () => {
      setLoading(true);
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/entities?q=${inputValue}`);
        // Limit results to 5
        setOptions(res.data.slice(0, 5));
      } catch (error) {
        console.error("Failed to fetch entity suggestions", error);
      } finally {
        setLoading(false);
      }
    };

    const debounceTimeout = setTimeout(() => {
      fetchSuggestions();
    }, 300); // Debounce input

    return () => clearTimeout(debounceTimeout);
  }, [inputValue]);

  return (
    <Autocomplete
      freeSolo
      options={options}
      inputValue={inputValue}
      onInputChange={(e, newInputValue) => setInputValue(newInputValue)}
      value={value}
      onChange={(e, newValue) => onChange(newValue || "")}
      loading={loading}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Select Entity"
          variant="outlined"
          fullWidth
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
}
